function normalizePath(pathname) {
  return pathname.replace(/\/+$/, "") || "/";
}

function isSamePage(url) {
  return (
    url.origin === window.location.origin &&
    normalizePath(url.pathname) === normalizePath(window.location.pathname)
  );
}

function scrollToId(id, { smooth = true } = {}) {
  if (!id) return false;

  const target = document.getElementById(id);
  if (!target) return false;

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  target.scrollIntoView({
    behavior: reduceMotion || !smooth ? "auto" : "smooth",
    block: "start",
  });
  return true;
}

function idFromHash(hash) {
  if (!hash || hash === "#") return "";
  try {
    return decodeURIComponent(hash.slice(1));
  } catch {
    return hash.slice(1);
  }
}

function scrollToLocationHash() {
  return scrollToId(idFromHash(window.location.hash), { smooth: false });
}

export function initHashScroll() {
  document.addEventListener("click", (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest("a[href]");
    if (!link) return;

    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch {
      return;
    }

    if (!url.hash || !isSamePage(url)) return;

    const id = idFromHash(url.hash);
    if (!document.getElementById(id)) return;

    event.preventDefault();
    if (url.hash !== window.location.hash) {
      history.pushState(null, "", url.hash);
    }
    scrollToId(id);
  });

  window.addEventListener("hashchange", scrollToLocationHash);

  if (!window.location.hash) return;

  scrollToLocationHash();
  window.addEventListener("load", scrollToLocationHash, { once: true });
}
